<template>
  <video :src="url.video" controls></video>
</template>

<script>
import { getVideoId } from '@/api/educational'

export default {
  name: 'video',
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    this.video()
  },
  methods: {
    async video () {
      const { result } = await getVideoId(this.$route.params.id)
      console.log(result)
      this.url = result
    }
  }
}
</script>

<style scoped>
  video {
    position:absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000;
  }
</style>
